import { styled } from '@linaria/react'
import { AvatarStyled } from 'atoms/Avatar'
import { Button } from 'atoms/Button'
import { AvatarBlockStyled } from 'blocks/AvatarBlock'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const BackButtonSC = styled(Button)`
  &[data-arcana-button='true'] {
    position: absolute;
    top: 16px;
    left: 8px;

    ${MEDIA.MIN_1240} {
      top: 40px;
      left: 40px;
    }
  }
`

export const ChooseProfileAvatarsSC = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: var(${FIXED_INDENTS.INDENT_50});

  ${AvatarStyled} {
    width: 96px;
    height: 96px;
  }

  ${AvatarBlockStyled} {
    width: 96px;
  }

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_60});
    max-width: 396px;

    ${AvatarStyled} {
      width: 116px;
      height: 116px;
    }

    ${AvatarBlockStyled} {
      width: 116px;
    }
  }

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_80});
    max-width: 566px;
  }

  ${MEDIA.MIN_1440} {
    flex-wrap: nowrap;
    gap: var(${FIXED_INDENTS.INDENT_80});
    max-width: initial;
  }
`

export const ChooseProfileSC = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(${FIXED_INDENTS.INDENT_80});
  padding: var(${FIXED_INDENTS.INDENT_300}) var(${FIXED_INDENTS.INDENT_40});

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_450}) 0 var(${FIXED_INDENTS.INDENT_290});
    gap: var(${FIXED_INDENTS.INDENT_100});
  }

  ${MEDIA.MIN_1240} {
    width: 100%;
    height: 100%;
    padding: 0;
    gap: var(${FIXED_INDENTS.INDENT_140});
  }

  ${MEDIA.MIN_1440} {
    gap: var(${FIXED_INDENTS.INDENT_120});
  }

  ${MEDIA.MIN_1920} {
    gap: var(${FIXED_INDENTS.INDENT_160});
  }
`
